/*
 * @Author: Dzy
 * @Date: 2022-08-19 09:51:11
 * @LastEditors: xiangwenheng
 * @LastEditTime: 2022-12-01 13:20:47
 * @Description: Desc
 */
import { getUinfo } from '@/api/auth.js'
import { checkResult } from '@/utils/tools'
import { setHeader } from '@/utils/request'
import { useRequest } from 'vue-request'
import { storeToRefs } from 'pinia'
import useStore from '@/store'
import { QINIU_BASE_URL } from '@Con'
let commonPath = ''

/**
 * 将菜单列表构建为树形结构
 * @param {Object}} uinfo 用户角色数据
 * @returns
 */
const createMenuTree = (uinfo) => {
  const { menus } = uinfo

  if (menus.length) {
    const rootNode = []
    menus.forEach((menu, index) => {
      if (menu.pid == '0') {
        rootNode.push(menu.menuId)

        menus.splice(index, 1)
      }
    })

    uinfo.menuTree = menus.filter((e) => !e.pid || rootNode.includes(e.pid))
    uinfo.menuTree.forEach((item) => {
      item.menuPath = uinfo.currentTypePath + item.menuPath
    })
    uinfo.menuTree.sort((a, b) => {
      const num1 = Number(a.sortNum / 1)
      const num2 = Number(b.sortNum / 1)
      return num1 - num2
    })
    uinfo.menuTree.forEach((menu) => {
      menu.level = 1
      menuTreeBuildChild(menu, menus)
    })
    uinfo.menuTree.forEach((mt) => {
      let defaultFun = mt
      while (defaultFun.children && defaultFun.children.length) {
        defaultFun = defaultFun.children[0]
      }
      mt.defaultPath = defaultFun.menuPath
    })
    delete uinfo.menus

    return true
  } else {
    return false
  }
}

const menuTreeBuildChild = (menu, menus) => {
  menu.buttons = menus.filter((e) => e.pid == menu.menuId && e.menuType == '1')
  menu.children = menus.filter((e) => e.pid == menu.menuId && e.menuType == '0')
  if (menu.children && menu.children.length) {
    menu.children.sort((a, b) => {
      const num1 = Number(a.sortNum / 1)
      const num2 = Number(b.sortNum / 1)
      return num1 - num2
    })
    menu.children.forEach((menu2) => {
      menu2.level = menu.level + 1
      menu2.menuPath = menu.menuPath + menu2.menuPath
      menuTreeBuildChild(menu2, menus)
    })
  }
}
let buttonPermissions = []
const testArr = (arr) => {
  if (arr) {
    arr.forEach((el) => {
      const obj = {}
      obj.menuName = el.menuName
      obj.menuPath = el.menuPath
      obj.buttons = el.buttons || []
      buttonPermissions.push(obj)
      if (el.children.length) {
        testArr(el.children)
      }
    })
  }
}
/**
 * @description: 根据登录返回账号信息构建用户及菜单体系
 * @param {*} update_allAccounts 更新当前账户所有角色信息
 * @param {*} update_uinfo 更新该账户所有信息
 * @param {*} uinfo 登陆账号所有信息
 * @return {*}
 */
export const buildUinfos = ({ update_allAccounts, update_uinfo }, uinfo, roleId) => {
  const { config } = useStore()
  const { title, icon, loginImg } = storeToRefs(config)

  if (uinfo.accounts && uinfo.accounts.length) {
    let tempUinfo = {}
    let tempAllAccounts = []
    let tempMenu = []

    Object.keys(uinfo).forEach((key) => {
      if (key == 'accounts') tempAllAccounts = uinfo[key]
      else tempUinfo[key] = uinfo[key]
    })
    delete uinfo.accounts

    tempAllAccounts.forEach((account) => {
      if (account.presentFlag) {
        // 已经选择了角色
        const findItem = account.roles.find((role) => role.menus?.length > 0)
        // const findItem = account.roles.find((role) => role.roleId == roleId)
        tempMenu = findItem? findItem.menus : []
        let currentTypePath = ''

        if (account.platformName) {
          title.value = account.platformName
        } else {
          title.value = '哪吒爱动智慧体育平台'
        }
        if (account.icon) {
          icon.value = QINIU_BASE_URL + account.icon
        } else {
          icon.value = QINIU_BASE_URL + '/V2/icon.png'
        }
        document.getElementById('showTitle').innerHTML = title.value
        document.getElementById('showIcon').href = icon.value

        if (account.orgType == '10') {
          // 管理机构
          currentTypePath = '/admin'
        }
        if (account.orgType == '21') {
          // k12
          currentTypePath = '/k12'
        }
        if (account.orgType == '22') {
          // gx
          currentTypePath = '/gx'
        }
        if (account.orgType == '41') {
          // nf
          currentTypePath = '/nf'
        }
        tempUinfo.currentTypePath = currentTypePath
        if(findItem){
          delete findItem.menus
        }
        tempUinfo.cAccount = account
      }
    })

    if (tempMenu.length) {
      tempUinfo.menus = tempMenu
      // 初次获取登录信息 没有菜单信息 需要切换角色后 才能获取相关菜单信息
      if (createMenuTree(tempUinfo)) {
        buttonPermissions = []

        tempAllAccounts.forEach((item) => {
          if (item.presentFlag) testArr(tempUinfo.menuTree)
        })
        localStorage.setItem('btnPermissionsListOper', JSON.stringify(buttonPermissions))
      } else {
        throw new Error('没有任何可用的角色权限信息，请联系管理员处理！')
      }
    }

    update_allAccounts(tempAllAccounts)

    update_uinfo(tempUinfo)

    return 1
  } else {
    throw new Error('没有任何可用的角色权限信息，请联系管理员处理！')
  }
}

export default (authStore, tokenStore) => {
  const { data: uinfoResult, runAsync: runUinfo, loading: uinfoLoading } = useRequest(getUinfo)

  const getUinfoByToken = async () => {
    setHeader(tokenStore.accessToken, tokenStore.tokenType + ' ' + tokenStore.accessToken)

    await runUinfo()
    if (checkResult(uinfoResult.value)) {
      return buildUinfos(authStore, uinfoResult.value.data)
    } else {
      throw new Error(uinfoResult.value.msg)
    }
  }

  return {
    uinfoLoading,

    getUinfoByToken
  }
}
